import { useContext } from 'react';
import { FeatureToggleContext } from '../providers/FeatureToggleProvider';
var useFeatureToggle = function () {
  var featureToggles = useContext(FeatureToggleContext).featureToggles;
  var featureEnabled = function (feature) {
    if (featureToggles.hasOwnProperty(feature)) {
      return featureToggles[feature];
    }
    return false;
  };
  return {
    featureEnabled: featureEnabled
  };
};
export default useFeatureToggle;